import { BREAKPOINT } from '@/modules/api'

export default class AdditionalNews {
  constructor (root, header, mainSlider) {
    this.root = root 
    this.pageHeader = header
    this.close = this.root.querySelector('.additional-news__msg--close') 
    this.pageSlider = mainSlider
  }

  toggleOnMobile () {
    if (window.innerWidth < BREAKPOINT.TABLET) {
      this.addClassesAndAttribute()
      this.close.addEventListener('click', e => this.removeClassesAndAttribute(e))
      this.root.addEventListener('click', () => this.addClassesAndAttribute())
    }
  }
  
  addClassesAndAttribute () {
    this.root.classList.add('pin-at-top', 'additional-news--sticky')
    this.pageHeader.style.marginTop = `${this.root.clientHeight}px`
    if (this.pageSlider) {
      this.pageSlider.style.marginTop = `${this.root.clientHeight + this.pageHeader.clientHeight}px`
    }
  }

  removeClassesAndAttribute (e) {
    e.stopPropagation()
    this.root.classList.remove('pin-at-top', 'additional-news--sticky')
    this.pageHeader.style.marginTop = '0px'
    if (this.pageSlider) {
      this.pageSlider.style.marginTop = '55px'
    }
  }
  init () {
    return this.toggleOnMobile()
  }

}


// WEBPACK FOOTER //
// ./src/components/AdditionalNews.js